import { ComponentProps, FC, ReactNode } from "react";
import { Link } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import styles from "./ListRow.module.css";

type IconProp = ComponentProps<typeof FontAwesomeIcon>["icon"];

interface ListRowProps {
  to: string;
  icon: IconProp;
  title: string;
  badges?: ReactNode;
  meta?: ReactNode;
}

export const ListRow: FC<ListRowProps> = ({
  to,
  icon,
  title,
  badges,
  meta,
}) => (
  <li className={styles.row}>
    <Link to={to} className={styles.link}>
      <span className={styles.icon}>
        <FontAwesomeIcon icon={icon} aria-hidden />
      </span>
      <span className={styles.content}>
        <span className={styles.title}>{title}</span>
        {(badges || meta) && (
          <span className={styles.subtitle}>
            {badges}
            {meta && <span className={styles.meta}>{meta}</span>}
          </span>
        )}
      </span>
      <FontAwesomeIcon
        icon={faChevronRight}
        className={styles.chevron}
        aria-hidden
      />
    </Link>
  </li>
);

export const ListRows: FC<{ children: ReactNode }> = ({ children }) => (
  <ul className={styles.list}>{children}</ul>
);
